import {FilterOfferType} from "../../../common/app/constants/enums";
import {OfferType} from "../../../common/app/routing/offer_type";

export interface ICityViewConfig {
    filterOfferType: FilterOfferType | null;
    propertyType: string;
    useTypeStats: boolean;
}

export const getCityViewConfig = (offerType: OfferType): ICityViewConfig => {
    switch (offerType) {
        case OfferType.FLAT:
            return {
                filterOfferType: FilterOfferType.FLATS,
                propertyType: "flats",
                useTypeStats: true
            };
        case OfferType.HOUSE:
            return {
                filterOfferType: FilterOfferType.HOUSES,
                propertyType: "houses",
                useTypeStats: true
            };
        default:
            return {
                filterOfferType: null,
                propertyType: "properties",
                useTypeStats: false
            };
    }
};
